<template>
  <!-- 产品详情 -->
  <div class="searchNew">
    <!-- 头部 -->
    <headerNav
      activeIndex="newsCenter"
      @setBanner="setBanner"
      @getValue="getValue"
    ></headerNav>
    <!-- 轮播图 -->
    <bannerNav
      :carousel="info.carousel"
      :Mcarousel="info.Mcarousel"
      class="pc"
    ></bannerNav>
    <div class="pc maxWidth" id="mainNav">
      <div style="display: flex">
        <div class="academicList" style="flex: 1">
          <div class="academicList-top">
            <div style="flex: 1">全部结果</div>
            <div>
              <el-input
                placeholder="请检索新闻内容"
                v-model="searchValue"
                @keyup.enter.native="getList"
              >
                <i
                  slot="suffix"
                  class="el-input__icon el-icon-search"
                  @click="getList"
                  style="cursor: pointer"
                ></i>
              </el-input>
            </div>
          </div>
          <div v-if="newsList.length > 0">
            <div
              class="academicList-main"
              v-for="(item, index) of newsList"
              :key="index"
              @click="goDetail(item.id)"
            >
              <div style="width: 250px; margin-right: 37px">
                <img
                  :src="getUrlPrefix(item.images)"
                  style="width: 100%"
                  alt=""
                />
              </div>
              <div
                style="
                  flex: 1;
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                "
              >
                <div>
                  <span class="academicList-main-title" v-html="item.title"></span>
                  | {{ item.releaseTime }}
                </div>
                <div class="academicList-main-content" v-html="item.description">
                  
                </div>
                <div class="academicList-Btn">
                  <a>查看详情</a>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="academicList-main">
              <div style="flex: 1;text-align:center;">暂无文章</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="mobile searchMobile"
      style="margin-top: 0.3rem; padding: 0.35rem 0; font-size: 0.16rem"
      :style="
        intShow === false || historyShow === true ? '' : 'background:#F5F5F5;'
      "
    >
      <div
        style="
          display: flex;
          align-items: center;
          border: 1px solid #e5e5e5;
          border-radius: 50px;
          padding: 0 0.16rem;
          background: #fff;
          margin: 0.3rem 0.2rem;
        "
      >
        <i class="el-icon-search"></i>
        <el-input
          placeholder="请输入关键字"
          style="width: 100%; border-radius: 50px"
          v-model="searchValue"
          @focus="historyShow = true"
          @blur="hideHistory"
        >
        </el-input>
        <el-button
          size="mini"
          style="
            background: linear-gradient(45deg, #7ace63 0%, #3f6b33 100%);
            color: #fff;
            border-radius: 50px;
            padding: 0 0.2rem;
            height: 0.38rem;
            font-size: 0.16rem;
          "
          @click="searchBtn"
          >搜索</el-button
        >
      </div>
      <div
        style="padding: 0 0.2rem; background: #fff"
        v-if="intShow === false || historyShow === true"
      >
        <div
          v-if="historyList.length > 0"
          style="font-size: 0.2rem; display: flex"
        >
          <div style="flex: 1">搜索历史</div>
          <i class="el-icon-delete" @click="resetHistory"></i>
        </div>
        <div style="display: flex; flex-wrap: wrap">
          <template v-if="historyList.length > 0">
            <div
              v-for="(item, index) of historyList"
              :key="index"
              style="
                padding: 0.05rem 0.16rem;
                margin: 0.1rem;
                background: #f8f8f8;
                border-radius: 20px;
                max-width: 100%;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
              "
              @click="selectHis(item)"
            >
              {{ item }}
            </div>
          </template>
        </div>
        <!-- <div style="font-size: 0.2rem; display: flex">
          <div style="flex: 1">热门搜索</div>
        </div>
        <div style="display: flex; flex-wrap: wrap">
          <template v-if="historyList.length > 0">
            <div
              v-for="(item, index) of historyList"
              :key="index"
              style="
                padding: 0.05rem 0.16rem;
                margin: 0.1rem;
                background: #f8f8f8;
                border-radius: 20px;
                max-width: 100%;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
              "
              @click="selectHis(item)"
            >
              {{ item }}
            </div>
          </template>
        </div> -->
      </div>
      <div
        v-else
        style="
          margin: 0 0.1rem;
          padding: 0.2rem 0.1rem 0.15rem;
          border-radius: 4px;
          background: #fff;
          border-radius: 10px;
        "
      >
        <div v-if="newsList.length === 0">
          <van-empty description="暂无信息" />
        </div>
        <div v-else v-loading="loading">
          <div
            style="
              text-align: center;
              font-size: 0.26rem;
              margin-bottom: 0.2rem;
            "
          >
            搜索结果
          </div>
          <div style="position: relative; margin-bottom: 0.2rem">
            <img
              src="@/assets/mobile/ye.png"
              style="width: 0.16rem; position: absolute; top: -0.15rem"
              alt=""
            />
            <div
              style="
                width: 99%;
                margin-left: 1%;
                height: 1px;
                background: #3f6b33;
              "
            ></div>
          </div>
          <div
            v-for="(item, index) of newsList"
            :key="index"
            style="
              display: flex;
              border-bottom: 1px solid #dddddd;
              padding: 0.16rem 0px;
              margin: 0px 0.1rem;
            "
            @click="goPhoneNews(item.id)"
          >
            <div
              style="flex: 1; margin-right: 0.2rem; font-size: 0.17rem"
              v-html="item.title"
            ></div>
            <div
              style="color: #999999; font-size: 0.17rem; margin-top: 0.02rem"
            >
              {{ item.releaseTime }}
            </div>
          </div>
          <div style="text-align: center; margin: 0.2rem 0 0; color: #666">
            下拉到底部了
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <RightBar></RightBar>
    <footerNav></footerNav>
  </div>
</template>

<script>
import headerNav from "@/components/headerNav/index";
import bannerNav from "@/components/banner/index";
import footerNav from "@/components/footerNav/index";
import {
  getConfByKey,
  updateReadingVolume,
  getNewsListBySearchName,
} from "@/api/common";
import {
  setTokenByName,
  getTokenByName,
  removeTokenByName,
} from "@/utils/auth";
export default {
  name: "search",
  components: { headerNav, footerNav, bannerNav },
  data() {
    return {
      info: {
        carousel: [],
        Mcarousel: "",
      }, //轮播图
      show: false,
      mobile: false,
      navIndex: 1,
      brandProfileNavShow: false,
      top: 100,
      numShow: false,
      currentPage1: 1,
      pageSize: 10,
      type: 1,
      total: 0,
      newsDetail: {}, //产品详情
      searchValue: "",
      historyList: [],
      intShow: false,
      historyShow: false,
      newsList: [],
      loading: false,
    };
  },
  mounted() {
    if (!this.isPhone() && !this.$route.query.key) {
      this.$router.push({ name: "home" });
    } else if (this.isPhone()) {
      this.getHistory();
    } else {
      this.searchValue = this.$route.query.key;
      this.getList();
    }
  },
  methods: {
    isPhone() {
      var userAgent = navigator.userAgent;
      var isMobile =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          userAgent
        );

      if (isMobile) {
        // 在移动设备上
        return true;
      } else {
        // 在PC端
        return false;
      }
    },
    setBanner(url, mUrl) {
      this.info = {
        carousel: [url],
        Mcarousel: [mUrl],
      };
    },
    // 获取搜索历史
    getHistory() {
      var historyList = getTokenByName("search");
      if (historyList !== undefined && historyList !== null) {
        this.historyList = historyList.split(",");
      }
    },

    goDetail(id) {
      this.$router.push({ name: "newsDetail", params: { id: id } });
    },
    resetHistory() {
      removeTokenByName("search");
      this.historyList = [];
    },
    getList() {
      getNewsListBySearchName({
        searchName: this.searchValue,
        efficacyId: "",
        type: "",
      }).then((res) => {
        this.loading = false;
        if (res.data.length !== 0) {
            res.data.forEach((item) => {
              var reg = this.searchValue;
              item.title = item.title.replace(
                reg,
                `<b style='color:red;'>${reg}</b>`
              );
              item.description = item.description.replace( 
                reg,
                `<b style='color:red;'>${reg}</b>`
              );
            });
          }
        this.newsList = res.data;
      });
    },
    searchBtn() {
      if (this.searchValue !== "" && this.searchValue !== null) {
        this.intShow = true;
        if (this.historyList.indexOf(this.searchValue) === -1) {
          this.historyList.splice(0, 0, this.searchValue);
          if (this.historyList.length > 20) {
            this.historyList.splice(20, 1);
          }
        } else {
          var index = this.historyList.indexOf(this.searchValue);
          this.historyList.splice(index, 1);
          this.historyList.splice(0, 0, this.searchValue);
        }
        setTokenByName("search", this.historyList.join(","));
        getNewsListBySearchName({
          searchName: this.searchValue,
          efficacyId: "",
          type: "",
        }).then((res) => {
          this.loading = false;
          if (res.data.length !== 0) {
            res.data.forEach((item) => {
              var reg = this.searchValue;
              item.title = item.title.replace(
                reg,
                `<b style='color:red;'>${reg}</b>`
              );
            });
          }
          this.newsList = res.data;
        });
      }
    },
    selectHis(name) {
      this.searchValue = name;
      this.searchBtn();
    },
    goPhoneNews(id) {
      // const routeData = this.$router.resolve({
      //   name: 'newsDetail',
      //   query: { id: id },
      // })
      // window.open(routeData.href, '_blank')
      this.$router.push({ name: "newsDetail", params: { id: id } });
    },
    hideHistory() {
      var that = this;
      setTimeout(() => {
        that.historyShow = false;
      }, 100);
    },
    getValue(val){
      console.log(val)
      this.searchValue = val
      this.getList()
    }
  },
};
</script>

<style lang="scss">
.searchNew {
  .searchMobile{
    .el-input {
      .el-input__inner {
        border: 0;
        background: #fff;
      }
    }
  }

  #mainNav {
    position: relative;
    padding: 20px 72px 148px;
  }
  .maxWidth {
    width: 1229px;
    margin: 0 auto;
  }
  .newsList {
    display: flex;
    align-items: center;
    margin-bottom: 67px;
    cursor: pointer;
    img {
      transition: all 0.5s;
    }
  }
  .selectLeft {
    background: #ffffff;
    box-shadow: 0px 2px 8px 0px #eef2f5;
    border-radius: 0px 0px 2px 2px;
    border-top: #86be1e 2px solid;
    padding: 0px 16px 10px 16px;
    box-sizing: border-box;
    width: 300px;
    margin-right: 60px;
    height: max-content;
  }
  .academicList {
    .academicList-top {
      background: #eef2f5;
      padding: 8px 10px;
      box-sizing: border-box;
      width: 100%;
      display: flex;
      align-items: center;
    }
    .academicList-main {
      width: 100%;
      padding: 20px 8px;
      box-sizing: border-box;
      border-bottom: #cccccc 1px dashed;
      display: flex;
      align-items: center;

      .academicList-Btn {
        margin-top:10px;
        a {
          width: 90px;
          text-align: center;
          height: 32px;
          background: #ffffff;
          border-radius: 2px;
          border: 1px solid #cccccc;
          font-size: 14px;
          font-weight: 400;
          color: #293a4c;
          line-height: 20px;
          box-sizing: border-box;
          margin-right: 8px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
        a:hover {
          background-color: #3f6b33;
          color: #fff;
          border: 1px solid #3f6b33;
        }
      }
      .academicList-main-title {
        cursor: pointer;
      }
      .academicList-main-title:hover {
        text-decoration: underline;
      }
      .academicList-main-content {
        margin-top: 8px;
        padding: 2px 0;
        box-sizing: border-box;
        display: flex;
        font-size: 14px;
        color: #666;
        display: -webkit-box;/* 兼容性 */
        -webkit-line-clamp:3; /* 指定显示行数 */
        -webkit-box-orient: vertical;/* 文本垂直排列 */
        overflow: hidden;/* 多余部分隐藏 */
        min-height: 42px;

      }
    }
    .academicList-main:hover {
      background-color: #f6f7f7;
    }
    .academicList-main:last-child {
      margin-bottom: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/search/index.vue